import { httpClient, KEM_BACKEND_API_URL } from "@ch/api";
import { NotifyError } from "@ch/helpers/utils/helpers";

interface KemHealthCheckResponse {
  health_status: string;
}

interface KemHealthCheckOptions {
  silent?: boolean;
}

const kemHealthCheck = async (
  options: KemHealthCheckOptions = {},
): Promise<boolean> => {
  const { silent = false } = options;

  try {
    const response = await httpClient<KemHealthCheckResponse>({
      baseURL: KEM_BACKEND_API_URL,
      url: "/health-check",
      method: "GET",
    });

    const ok = response?.data?.health_status === "Ok";
    if (!ok && !silent) {
      NotifyError("Kem is currently unavailable. Please try again later.");
    }
    return ok;
  } catch {
    if (!silent) {
      NotifyError("something went wrong. Please try again later.");
    }
    return false;
  }
};

export default kemHealthCheck;
